$bog_ui_app_overview $mol_page
	title \Components Overview
	body /
		<= Description $mol_view
			sub /
				<= description \Browse all available UI components. Click a card to see its full demo.
		<= Grid $mol_view
			sub <= cards /
				<= Card_badge $bog_ui_app_overview_card
					card_id \badge
					card_title \Badge
					card_description \Compact label with 5 color variants for status indication
					click? <=> go_badge? null
					Preview <= Badge_preview $mol_view
						sub /
							<= Badge_s $bog_ui_badge
								label \Success
								type \success
							<= Badge_e $bog_ui_badge
								label \Error
								type \error
							<= Badge_i $bog_ui_badge
								label \Info
								type \info
				<= Card_empty $bog_ui_app_overview_card
					card_id \empty
					card_title \Empty State
					card_description \Placeholder for pages with no content
					click? <=> go_empty? null
					Preview <= Empty_preview $mol_view
						sub /
							<= Empty_icon $mol_icon_magnify
							<= Empty_text $mol_view
								sub /
									\No results
				<= Card_skeleton $bog_ui_app_overview_card
					card_id \skeleton
					card_title \Skeleton
					card_description \Loading placeholder with shimmer animation
					click? <=> go_skeleton? null
					Preview <= Skeleton_preview $mol_view
						sub /
							<= Skel_1 $bog_ui_skeleton
							<= Skel_2 $bog_ui_skeleton
							<= Skel_3 $bog_ui_skeleton
				<= Card_breadcrumb $bog_ui_app_overview_card
					card_id \breadcrumb
					card_title \Breadcrumb
					card_description \Navigation breadcrumb trail with separator
					click? <=> go_breadcrumb? null
					Preview <= Breadcrumb_preview $mol_view
						sub /
							<= Bc_home $mol_view
								sub / \Home
							<= Bc_sep $mol_view
								sub / \>
							<= Bc_cat $mol_view
								sub / \Catalog
							<= Bc_sep2 $mol_view
								sub / \>
							<= Bc_cur $mol_view
								sub / \Page
				<= Card_sidebar $bog_ui_app_overview_card
					card_id \sidebar
					card_title \Sidebar
					card_description \Side navigation panel with 3 display modes
					click? <=> go_sidebar? null
					Preview <= Sidebar_preview $mol_view
						sub /
							<= Sb_bar $mol_view
								sub /
									<= Sb_i1 $mol_icon_home
									<= Sb_i2 $mol_icon_account
									<= Sb_i3 $mol_icon_cog
							<= Sb_content $mol_view
								sub /
									\Content
				<= Card_sheet $bog_ui_app_overview_card
					card_id \sheet
					card_title \Sheet
					card_description \Overlay panel sliding from screen edge
					click? <=> go_sheet? null
					Preview <= Sheet_preview $mol_view
						sub /
							<= Sheet_box $mol_view
								sub /
									<= Sheet_panel $mol_view
										sub /
											\Panel
				<= Card_toast $bog_ui_app_overview_card
					card_id \toast
					card_title \Toast
					card_description \Notification messages with 4 severity types
					click? <=> go_toast? null
					Preview <= Toast_preview $mol_view
						sub /
							<= Toast_info_mini $mol_view
								sub /
									<= Toast_info_icon $mol_icon_information
									\Info message
							<= Toast_ok_mini $mol_view
								sub /
									<= Toast_ok_icon $mol_icon_check_circle
									\Success!
				<= Card_command $bog_ui_app_overview_card
					card_id \command
					card_title \Command Palette
					card_description \Search and execute commands via keyboard
					click? <=> go_command? null
					Preview <= Command_preview $mol_view
						sub /
							<= Cmd_search $mol_view
								sub /
									<= Cmd_icon $mol_icon_magnify
									\Search commands...
				<= Card_table $bog_ui_app_overview_card
					card_id \table
					card_title \Data Table
					card_description \Sortable data grid with row selection
					click? <=> go_table? null
					Preview <= Table_preview $mol_view
						sub /
							<= Tbl_head $mol_view
								sub /
									\Name
									\Email
									\Role
							<= Tbl_row1 $mol_view
								sub /
									\Alice
									\a@b.c
									\Dev
							<= Tbl_row2 $mol_view
								sub /
									\Bob
									\b@b.c
									\PM

$bog_ui_app_overview_card $mol_button_minor
	card_id \
	card_title \
	card_description \
	Preview $mol_view
	attr *
		^
		bog_ui_app_overview_card true
	sub /
		<= Preview
		<= Title $mol_view
			sub /
				<= card_title
		<= Card_desc $mol_view
			sub /
				<= card_description
